import { PointsKey } from "@silo/types";
import { match } from "ts-pattern";
import {
  AnzenIcon,
  BedrockIcon,
  EigenLayerIcon,
  EtherFiIcon,
  KelpIcon,
  MellowIcon,
  RenzoIcon,
  SwellIcon,
  SymbioticIcon,
  TurtleIcon,
} from "../../icons";

interface PointsIconProps {
  className?: string;
  pointsKey: PointsKey;
}

export function PointsIcon({
  className,
  pointsKey,
}: PointsIconProps): JSX.Element {
  return match(pointsKey)
    .with("eigenLayer", () => <EigenLayerIcon className={className} />)
    .with("etherFi", () => <EtherFiIcon className={className} />)
    .with("kelp", () => <KelpIcon className={className} />)
    .with("renzo", () => <RenzoIcon className={className} />)
    .with("swell", () => <SwellIcon className={className} />)
    .with("mellow", () => <MellowIcon className={className} />)
    .with("symbiotic", () => <SymbioticIcon className={className} />)
    .with("bedrock", () => <BedrockIcon className={className} />)
    .with("turtle", () => <TurtleIcon className={className} />)
    .with("anzen", () => <AnzenIcon className={className} />)
    .exhaustive();
}
